import type {Context} from '../types';

// Change innerHtml binding filter for Option types
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const innerHtml = data.dyn && data.dyn.bind && data.dyn.bind.innerHTML;

  const _iterateInnerHTMLBindings = (_jsonNode: Record<any, any>, fn: any) => {
    const innerHTMLBindings = innerHtml;
    if (innerHTMLBindings) {
      const optionFilter = 'option|option';
      innerHTMLBindings.forEach(function (binding: any) {
        if (binding.type === 'Option' && binding.filter !== optionFilter) {
          fn(binding, optionFilter);
        }
      });
    }
  };

  let needed = false;

  _iterateInnerHTMLBindings(jsonNode, () => {
    needed = true;
  });

  return {
    needed,
    logData: {
      msg: 'InnerHtml binding with Option type filter not set to "option|option"',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      _iterateInnerHTMLBindings(
        jsonNode,
        (binding: any, optionFilter: string) => {
          binding.filter = optionFilter;
        }
      );
    },
  };
};
